import DataTable from "../../../components/DataTable/DataTable";
import useModal from "../../../hooks/useModal";
import { useStore } from "../../../store/useStore";
import { InfractionRanking } from "../../../store/types/infraction";
import { PERMISSIONS } from "../../../utils/constants/permissions";
import InfractionsConsolidatedModal from "./InfractionConsolidatedModal";

const InfractionRankingTable = () => {
  const { openModal } = useModal();
  const getInfractionConsolidated = useStore((state) => state.infraction.getInfractionConsolidated);
  const getInfractionTypePerPeriodChartData = useStore((state) => state.infraction.getInfractionTypePerPeriodChartData);
  const infractionRanking = useStore((state) => state.infraction.infractionRankingList.data);
  const setFilters = useStore((state) => state.infraction.infractionRankingList.setFilters);
  const filters = useStore((state) => state.infraction.infractionRankingList.filters);
  const isLoadingInfractionRankingList = useStore(
    (state) => state.infraction.isLoadingInfractionRankingList
  );
  const hasPermissions = useStore((state) => state.admin.hasPermissions);
  const handleTableOrder = (key: string) => {
    let sort_value = "asc";
    if (filters.sort_key === key) {
      sort_value = filters.sort_value === "asc" ? "desc" : "asc";
    }
    setFilters({ ...filters, sort_key: key, sort_value });
  };

  const openInfractionsConsolidatedModal = (userId: string) => {
    getInfractionConsolidated(userId, filters.reference_month !== "" ? filters.reference_month : filters.start_date);
    getInfractionTypePerPeriodChartData(userId);
    openModal(<InfractionsConsolidatedModal onClose={() => {}} />);
  };

  const columns = [
    {
      key: "ranking",
      label: "",
      render: (item: InfractionRanking) => {
        return (
          item?.ranking ? 
          <div className="inline-flex items-center justify-center w-8 h-8 mr-1 bg-gray_0 text-gray_3 font-bold rounded-full mt-[3px]">{item?.ranking}</div> 
          : '-'
        )
      }
    },
    {
      key: "name",
      label: "Motorista",
      render: (item: InfractionRanking) => item?.name ?? '-',
    },
    {
      key: "total",
      label: "Infrações",
      render: (item: InfractionRanking) => item?.total ?? '-',
      //sortKey: "total",
    },
    {
      key: "journeys_count",
      label: "Jornadas",
      render: (item: InfractionRanking) => item?.journeys_count ?? '-',
      //sortKey: "journeys_count",
    },
    {
      key: "average",
      label: "Média",
      render: (item: InfractionRanking) => {
        return parseFloat(item.average.toFixed(2)).toString() ?? '-'
      },
      //sortKey: "average",
    }
  ];

  return (
      <DataTable
        data={infractionRanking}
        columns={columns}
        onDetails={
          hasPermissions([PERMISSIONS.READ_INFRACTIONS_CONSOLIDATED]) ? openInfractionsConsolidatedModal : null
        }
        onOrder={handleTableOrder}
        sortKey={filters.sort_key}
        sortValue={filters.sort_value}
        loading={isLoadingInfractionRankingList}
      />
  )
};

export default InfractionRankingTable;
